/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

@-webkit-keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}

@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
:host {
  display: inline-block;
  vertical-align: middle;
}
:host .circle {
  height: 1.2857142857rem;
  width: 1.2857142857rem;
  margin-top: 0.2857142857rem;
  margin-right: 0.5714285714rem;
  margin-bottom: 0.2857142857rem;
  margin-left: 0.1428571429rem;
  border: 0.1428571429rem solid;
  border-radius: 50%;
  border-color: var(--davinci-color-mid-gray-3,#C5CACC) var(--davinci-color-primary,#007CC1) var(--davinci-color-mid-gray-3,#C5CACC) var(--davinci-color-mid-gray-3,#C5CACC);
  -webkit-animation: spin 850ms infinite cubic-bezier(0.13, 0.2, 0.8, 0.87);
          animation: spin 850ms infinite cubic-bezier(0.13, 0.2, 0.8, 0.87);
}
:host .label {
  display: none;
}

:host([label]) .circle {
  display: inline-block;
  vertical-align: middle;
  height: 1rem;
  width: 1rem;
}
:host([label]) .label {
  display: inline-block;
  vertical-align: middle;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  line-height: 1.5714285714rem;
}

:host([below]) {
  text-align: center;
}
:host([below]) .label {
  display: block;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  line-height: 1.5714285714rem;
}

:host([hidden]) {
  display: none;
}`;
export { style };
